export const SITE_TYPE = "OOPY";
